<template>
    <el-card class="scoreWrapper">
        <div class="score_top">
            <ul>
                <li>可用余额：<span>{{gfenData.num}}G</span></li>
                <li class="income">累计收入：<span>{{ gfenData.gfenIncomSum }}G</span></li>
                <li class="expend">累计支出：<span>{{ gfenData.gfenPaySum }}G</span></li>
            </ul>
        </div>
        <div class="score_bottom">
            <div class="title">
                <ul>
                    <li>收支明细</li>
                    <li class="selected">
                        <el-select v-model="defaultTime" @change="selectTime">
                            <el-option
                                    v-for="item in timer"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="defaultFlag" @change="selectFlag">
                            <el-option
                                    v-for="item in detail"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </li>
                </ul>
                <div class="tableData">
                    <el-table
                            :data="tableData"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="detailID"
                                label="流水号"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="createDate"
                                label="创建时间"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="detailName"
                                label="名称">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                label="收入支出">
                            <template slot-scope="scope">
                                <div :style="{'color':scope.row.flag === 0 ? '#de000a':'#de000a'}"
                                     v-if="scope.row.flag === 0">+{{ scope.row.num }}
                                </div>
                                <div :style="{'color':scope.row.flag === 1 ? '#75d900':'#75d900'}"
                                     v-if="scope.row.flag === 1">-{{ scope.row.num }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-pagination
                class="paging"
                :current-page="pageNum"
                layout="prev, pager, next"
                :total="pageTotal"
                background
                :page-size="pageSize"
                prev-text="上一页"
                next-text="下一页"
                @current-change="handleCurrentChange"
        />
    </el-card>
</template>
<script>
  import { getAccountApi, getGfenDetilApi } from '@/api/gIntegral';
  import { $Cookies } from '@/utils';

  export default {
    name: '',
    data() {
      return {
        userNo: null,
        gfenData: {
          gfenIncomSum: '',
          gfenPaySum: '',
          num: ''
        },
        timer: [
          {
            value: '1',
            label: '近1个月'
          }, {
            value: '3',
            label: '近3个月'
          }, {
            value: '0',
            label: '全部'
          }],
        detail: [
          {
            value: '0',
            label: '收入'
          }, {
            value: '1',
            label: '支出'
          }
        ],
        tableData: [],
        pageNum: 1,
        pageSize: 5,
        pageTotal: 0,
        defaultTime: '1',
        defaultFlag: '0'
      };
    },
    computed: {
      idList() {
        const { defaultTime, defaultFlag } = this;
        return {
          defaultTime,
          defaultFlag
        };
      }
    },
    watch: {
      idList() {
        this.getGfenDetilApi();
      }
    },
    async mounted() {
      this.userNo = Number($Cookies.get('uid'));
      await this.getAccountApi();
      await this.getGfenDetilApi();
    },
    methods: {
      selectTime(e) {
        this.defaultTime = e;
      },
      selectFlag(e) {
        this.defaultFlag = e;
      },
      getAccountApi() {
        const id = this.userNo;
        getAccountApi(id).then(data => {
          if (data.success) {
            this.gfenData = data.result;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      getGfenDetilApi() {
        const params = {
          userNo: this.userNo,
          time: this.defaultTime,
          flag: this.defaultFlag,
          pageNum: this.pageNum,
          pageSize:this.pageSize
        };
        getGfenDetilApi(params).then(data => {
          if (data.success) {
            this.tableData = data.result.list;
            this.pageTotal = data.result.total;
            this.pageNum = data.result.pageNum;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      handleCurrentChange(size) {
        this.pageNum = size;
        this.getGfenDetilApi();
      }
    }
  };
</script>
